<template>
  <div class='EnbNave03'
  :style="{ 
    backgroundColor: Prefes.nave.corBackground,
    fontFamily: Prefes.nave.font,
    color: Prefes.nave.corFont,
    fontStyle: parseInt(Prefes.nave.fontStyle) ? 'italic' : '',
    fontWeight: parseInt(Prefes.nave.fontBold) ? 'bold' : '',
    textDecoration: parseInt(Prefes.nave.textDecoration) ? 'underline' : '',
    fontSize: Prefes.nave.fontHeight + 'px'
  }"
  >
    <div class="cont-nave">
      <div class="logo-link">
        <div class="cont-logo">
          <enb-logo/>
        </div>
        <div class="cont-link">
          <enb-link
          v-for="(l, key) in Categorias.length ? Categorias.filter(c  => c.name !== '') : [{ name: 'Imóveis', icon: 'MapIcon', link: '' }]"
          :key="key"
          :data="l"
          />
        </div>
      </div>
      <div class="login-search">
        <div class="c-action">
          <search-icon :color="Prefes.nave.corFont" @click="SetModal01({ component: 'EnbSearch', active: true })"/>
        </div> 
        <div class="c-action">
          <user-icon :color="Prefes.nave.corFont" v-if="!Object.keys(Profile).length" @click="SetModal01({ component: 'EnbLogin', active: true })"/>
          <user-icon :color="Prefes.nave.corFont" v-if="Object.keys(Profile).length" @click="$router.push('/profile')"/>
         </div>
       </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EnbLogo from './EnbLogo'
import EnbLink from './EnbLink'
import UserIcon from '../Icons/UserIcon'
import SearchIcon from '../Icons/SearchIcon'
export default {
  name: 'EnbNave03',
  components: { EnbLogo, EnbLink, UserIcon, SearchIcon },
  computed: {
    ...mapGetters(['Profile', 'Categorias', 'Prefes'])
  },
  methods: {
    ...mapActions(['SetModal01', 'GetCategory'])
  },
  created () {
    this.GetCategory()
  }
}
</script>

<style scoped>
.EnbNave03 {
  width: 100%;
  height: 150px;
  display: flex;
  align-items: center;
  border-bottom: thin solid orange;
}

.cont-nave {
  width: 80%;
  height: 100%;
  display: flex;
  margin: auto;
}

.logo-link {
  width: 90%;
  height: 100%;
  display: flex;
}

.cont-logo {
  width: 20%;
}

.cont-link {
  width: 80%;
  display: flex;
  flex-wrap: wrap;
  margin: auto;
}

.login-search {
  width: 10%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
}

.c-action {
  padding-right: 5%;
}

@media (max-width: 500px) {
  .EnbNave03 {
    display: none;
  }
}
</style>
